import { RelationTagsTracking } from "./relationTagsTracking";


export class RelationInits {
    constructor() {
        this.initMap();
    }

    initMap() {
        new RelationTagsTracking();
    }
}
